import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../modules/contactsActions'
import * as api from '../api/contact'
import * as apiJob from '../api/job/contacts'

// used by jobContacts.js
export function* getAllContacts() {
  try {
    const payload = yield call(apiJob.getAllContacts)
    yield put({ type: constants.GET_ALL_CONTACTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_ALL_CONTACTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAllContacts() {
  yield takeLatest(constants.GET_ALL_CONTACTS.ACTION, getAllContacts)
}

// used by contacts/index.js
export function* getContactList() {
  try {
    const payload = yield call(api.getContactsList)
    yield put({ type: constants.GET_CONTACT_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_CONTACT_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetContactList() {
  yield takeLatest(constants.GET_CONTACT_LIST.ACTION, getContactList)
}

function* createContactIndividual(action) {
  try {
    const payload = {
      content: action.content,
      created_by_id: action.userId,
      updated_by_id: action.userId
    }
    yield call(api.createContactIndividual, payload)
    yield put({ type: constants.CREATE_CONTACT_INDIVIDUAL.SUCCESS, payload })
    yield put({ type: constants.GET_CONTACT_LIST.ACTION })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_CONTACT_INDIVIDUAL.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateContactIndividual() {
  yield takeLatest(constants.CREATE_CONTACT_INDIVIDUAL.ACTION, createContactIndividual)
}

function* editContactIndividual(action) {
  try {
    const payload = {
      content: action.content,
      contactId: action.contactId,
      created_by_id: action.userId,
      updated_by_id: action.userId
    }
    yield call(api.editContactIndividual, payload)
    yield put({ type: constants.EDIT_CONTACT_INDIVIDUAL.SUCCESS, payload })
    yield put({ type: constants.GET_CONTACT_LIST.ACTION })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.EDIT_CONTACT_INDIVIDUAL.FAILED,
      message: e.message || e
    })
  }
}

function* watchEditContactIndividual() {
  yield takeLatest(constants.EDIT_CONTACT_INDIVIDUAL.ACTION, editContactIndividual)
}

function* deleteContactIndividual(action) {
  try {
    const payload = {
      contactId: action.contactId
    }
    yield call(api.deleteContactIndividual, payload)
    yield put({ type: constants.DELETE_CONTACT_INDIVIDUAL.SUCCESS, payload })
    yield put({ type: constants.GET_CONTACT_LIST.ACTION })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_CONTACT_INDIVIDUAL.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteContactIndividual() {
  yield takeLatest(constants.DELETE_CONTACT_INDIVIDUAL.ACTION, deleteContactIndividual)
}

function* addEmail(action) {
  try {
    const payload = {
      contactId: action.contactId,
      address: action.address,
      emailType: action.emailType
    }
    yield call(api.addEmail, payload)
    yield put({ type: constants.ADD_EMAIL.SUCCESS, payload })
    yield call(getEmails, { contactId: action.contactId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.ADD_EMAIL.FAILED,
      message: e.message || e
    })
  }
}

function* watchAddEmail() {
  yield takeLatest(constants.ADD_EMAIL.ACTION, addEmail)
}

function* editEmail(action) {
  try {
    const payload = {
      emailId: action.emailId,
      contactId: action.contactId,
      address: action.address,
      emailType: action.emailType
    }
    yield call(api.editEmail, payload)
    yield put({ type: constants.EDIT_EMAIL.SUCCESS, payload })
    yield call(getEmails, { contactId: action.contactId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.EDIT_EMAIL.FAILED,
      message: e.message || e
    })
  }
}

function* watchEditEmail() {
  yield takeLatest(constants.EDIT_EMAIL.ACTION, editEmail)
}

function* deleteEmail(action) {
  try {
    const payload = {
      emailId: action.emailId,
      contactId: action.contactId
    }
    yield call(api.deleteEmail, payload)
    yield put({ type: constants.DELETE_EMAIL.SUCCESS, payload })
    yield call(getEmails, { contactId: action.contactId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_EMAIL.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteEmail() {
  yield takeLatest(constants.DELETE_EMAIL.ACTION, deleteEmail)
}

export function* getEmails(action) {
  try {
    const payload = yield call(api.getEmails, action.contactId)
    yield put({ type: constants.GET_EMAILS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_EMAILS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetEmails() {
  yield takeLatest(constants.GET_EMAILS.ACTION, getEmails)
}

function* addPhone(action) {
  try {
    const payload = {
      contactId: action.contactId,
      number: action.number,
      phoneType: action.phoneType
    }
    yield call(api.addPhone, payload)
    yield put({ type: constants.ADD_PHONE.SUCCESS, payload })
    yield call(getPhones, { contactId: action.contactId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.ADD_PHONE.FAILED,
      message: e.message || e
    })
  }
}

function* watchAddPhone() {
  yield takeLatest(constants.ADD_PHONE.ACTION, addPhone)
}

function* editPhone(action) {
  try {
    const payload = {
      phoneId: action.phoneId,
      contactId: action.contactId,
      number: action.number,
      phoneType: action.phoneType
    }
    yield call(api.editPhone, payload)
    yield put({ type: constants.EDIT_PHONE.SUCCESS, payload })
    yield call(getPhones, { contactId: action.contactId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.EDIT_PHONE.FAILED,
      message: e.message || e
    })
  }
}

function* watchEditPhone() {
  yield takeLatest(constants.EDIT_PHONE.ACTION, editPhone)
}

function* deletePhone(action) {
  try {
    const payload = {
      phoneId: action.phoneId,
      contactId: action.contactId
    }
    yield call(api.deletePhone, payload)
    yield put({ type: constants.DELETE_PHONE.SUCCESS, payload })
    yield call(getPhones, { contactId: action.contactId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_PHONE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeletePhone() {
  yield takeLatest(constants.DELETE_PHONE.ACTION, deletePhone)
}

export function* getPhones(action) {
  try {
    const payload = yield call(api.getPhones, action.contactId)
    yield put({ type: constants.GET_PHONES.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_PHONES.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetPhones() {
  yield takeLatest(constants.GET_PHONES.ACTION, getPhones)
}

function* getCompanyContacts(action) {
  try {
    const payload = yield call(apiJob.getCompanyContacts, action)
    yield put({ type: constants.GET_COMPANY_CONTACTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_COMPANY_CONTACTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetCompanyContacts() {
  yield takeLatest(constants.GET_COMPANY_CONTACTS.ACTION, getCompanyContacts)
}

function* sagaCompanyCreateContact(action) {
  try {
    const payload = {
      contact: {
        first_name: action.contact.first_name,
        last_name: action.contact.last_name,
        role: action.contact.role,
        company: action.companyId,
        phone_number: action.contact.phone_number,
        mobile_number: action.contact.mobile_number,
        email: action.contact.email
      },
      user_id: action.userId
    }

    yield call(apiJob.companyCreateContact, payload)
    yield put({ type: constants.COMPANY_CREATE_CONTACT.SUCCESS, payload })
    yield call(getCompanyContacts, { companyId: action.companyId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.COMPANY_CREATE_CONTACT.FAILED,
      message: e.message || e
    })
  }
}

function* watchCompanyCreateContact() {
  yield takeLatest(constants.COMPANY_CREATE_CONTACT.ACTION, sagaCompanyCreateContact)
}

function* sagaCompanyCreateContactById(action) {
  try {
    const payload = {
      contact_id: action.contactId,
      company_id: action.companyId,
      user_id: action.userId
    }

    yield call(api.companyCreateContactById, payload)
    yield put({ type: constants.COMPANY_CREATE_CONTACT_BY_ID.SUCCESS, payload })
    yield call(getCompanyContacts, { companyId: action.companyId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.COMPANY_CREATE_CONTACT_BY_ID.FAILED,
      message: e.message || e
    })
  }
}

function* watchCompanyCreateContactById() {
  yield takeLatest(constants.COMPANY_CREATE_CONTACT_BY_ID.ACTION, sagaCompanyCreateContactById)
}

function* sagaCompanyUpdateContact(action) {
  try {
    const payload = {
      contact: {
        first_name: action.contact.first_name,
        last_name: action.contact.last_name,
        role: action.contact.role
      },
      user_id: action.userId,
      contact_id: action.contactId
    }

    yield call(apiJob.companyUpdateContact, payload)
    yield put({ type: constants.COMPANY_UPDATE_CONTACT.SUCCESS, payload })
    yield call(getCompanyContacts, { companyId: action.companyId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.COMPANY_UPDATE_CONTACT.FAILED,
      message: e.message || e
    })
  }
}

function* watchCompanyUpdateContact() {
  yield takeLatest(constants.COMPANY_UPDATE_CONTACT.ACTION, sagaCompanyUpdateContact)
}

function* sagaCompanyDeleteContact(action) {
  try {
    const payload = {
      contact_id: action.contactId,
      company_id: action.companyId
    }
    yield call(apiJob.companyDeleteContact, payload)
    yield put({ type: constants.COMPANY_DELETE_CONTACT.SUCCESS, payload })
    yield call(getCompanyContacts, { companyId: action.companyId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.COMPANY_DELETE_CONTACT.FAILED,
      message: e.message || e
    })
  }
}

function* watchCompanyDeleteContact() {
  yield takeLatest(constants.COMPANY_DELETE_CONTACT.ACTION, sagaCompanyDeleteContact)
}

// notes
function* fetchContactNote(action) {
  try {
    const payload = yield call(api.fetchContactNote, { contactId: action.contactId })
    yield put({ type: constants.GET_CONTACT_NOTE.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_CONTACT_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchContactNote() {
  yield takeLatest(constants.GET_CONTACT_NOTE.ACTION, fetchContactNote)
}

function* createContactNote(action) {
  try {
    const payload = {
      content: action.content,
      contactId: action.contactId
    }
    yield call(api.createContactNote, payload)
    yield put({ type: constants.CREATE_CONTACT_NOTE.SUCCESS, payload })
    yield call(fetchContactNote, { contactId: action.contactId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_CONTACT_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateContactNote() {
  yield takeLatest(constants.CREATE_CONTACT_NOTE.ACTION, createContactNote)
}

function* editContactNote(action) {
  try {
    const payload = {
      content: action.content,
      noteId: action.noteId
    }
    yield call(api.editContactNote, payload)
    yield put({ type: constants.EDIT_CONTACT_NOTE.SUCCESS, payload })
    yield call(fetchContactNote, { contactId: action.contactId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.EDIT_CONTACT_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchEditContactNote() {
  yield takeLatest(constants.EDIT_CONTACT_NOTE.ACTION, editContactNote)
}

function* deleteContactNote(action) {
  try {
    const payload = {
      noteId: action.noteId
    }
    yield call(api.deleteContactNote, payload)
    yield put({ type: constants.DELETE_CONTACT_NOTE.SUCCESS, payload })
    yield call(fetchContactNote, { contactId: action.contactId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_CONTACT_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteContactNote() {
  yield takeLatest(constants.DELETE_CONTACT_NOTE.ACTION, deleteContactNote)
}

// JOBS
function* fetchContactJob(action) {
  try {
    const payload = yield call(api.fetchContactJobs, { contactId: action.contactId })
    yield put({ type: constants.GET_CONTACT_JOB.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_CONTACT_JOB.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchContactJob() {
  yield takeLatest(constants.GET_CONTACT_JOB.ACTION, fetchContactJob)
}

// LEADS
function* fetchContactLeads(action) {
  try {
    const payload = yield call(api.fetchContactLeads, { contactId: action.contactId })
    yield put({ type: constants.GET_CONTACT_LEAD.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_CONTACT_LEAD.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchContactLeads() {
  yield takeLatest(constants.GET_CONTACT_LEAD.ACTION, fetchContactLeads)
}

export function* fetchContactGroupsByJobId(action) {
  try {
    const payload = yield call(api.fetchContactGroupsByJobId, { jobId: action.jobId })
    yield put({ type: constants.FETCH_CONTACT_GROUPS_BY_JOB_ID.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.FETCH_CONTACT_GROUPS_BY_JOB_ID.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchContactGroupsByJobId() {
  yield takeLatest(constants.FETCH_CONTACT_GROUPS_BY_JOB_ID.ACTION, fetchContactGroupsByJobId)
}

function* sagaUpdateCompanyPrimaryContact(action) {
  try {
    const payload = {
      contact_id: action.contactId,
      company_id: action.companyId
    }
    yield call(api.updateCompanyPrimaryContact, payload)
    yield put({ type: constants.UPDATE_COMPANY_PRIMARY_CONTACT.SUCCESS, payload })
    yield call(getCompanyContacts, { companyId: action.companyId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_COMPANY_PRIMARY_CONTACT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateCompanyPrimaryContact() {
  yield takeLatest(constants.UPDATE_COMPANY_PRIMARY_CONTACT.ACTION, sagaUpdateCompanyPrimaryContact)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchGetAllContacts),
    fork(watchGetContactList),
    fork(watchCreateContactIndividual),
    fork(watchEditContactIndividual),
    fork(watchDeleteContactIndividual),
    fork(watchAddEmail),
    fork(watchEditEmail),
    fork(watchDeleteEmail),
    fork(watchGetEmails),
    fork(watchAddPhone),
    fork(watchEditPhone),
    fork(watchDeletePhone),
    fork(watchGetPhones),
    fork(watchGetCompanyContacts),
    fork(watchCompanyCreateContact),
    fork(watchCompanyUpdateContact),
    fork(watchCompanyDeleteContact),
    //notes
    fork(watchFetchContactNote),
    fork(watchCreateContactNote),
    fork(watchEditContactNote),
    fork(watchDeleteContactNote),
    //JOB
    fork(watchFetchContactJob),
    // LEAD
    fork(watchFetchContactLeads),

    fork(watchCompanyCreateContactById),

    fork(watchFetchContactGroupsByJobId),
    fork(watchUpdateCompanyPrimaryContact)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/contactsSaga.js